import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { INPUT_TRACKING_TYPES, inputOnChange } from '../../../lib/utils';
import type { MonthlyPaymentInputProps } from '../types';
import {
  getFieldPlaceholderByCalculator,
  getFieldValueByCalculator,
} from '../utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const PrivateMortgageInsuranceInput = (
  props: MonthlyPaymentInputProps
): JSX.Element => {
  const {
    placeholder,
    value,
    error,
    errorMessage,
    calculator,
    dispatch,
    analytics,
    label = 'Private mortgage insurance (PMI)',
    tooltip = 'A policy that protects the lender from losing money if you default on the loan. Most borrowers pay for mortgage insurance if they make down payments less than 20%.',
    fullWidth = true,
  } = props;

  const analyticsEnabled = analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'mortgageInsurance',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      overridesValue: 'monthlyPayments',
      overrides: true,
      legacy,
      bedrock,
      fieldName: 'mortgageInsurancePayment',
      calculator,
      inputType: 'currency',
    });
  };

  const placeholderValue = _.isNil(placeholder)
    ? ''
    : num.formatCurrency(placeholder);
  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  return (
    <InputMoney
      label={label}
      tooltip={tooltip}
      placeholder={placeholderValue}
      value={currencyValue}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  const errorMessage = state?.validations?.mortgageInsurancePayment?.[0];
  const error = !!errorMessage;

  return {
    error,
    errorMessage,
    value: getFieldValueByCalculator(
      state,
      calculator,
      'privateMortgageInsurance'
    ),
    placeholder: String(
      getFieldPlaceholderByCalculator(
        state,
        calculator,
        'privateMortgageInsurance'
      )
    ),
  };
};

export default connect(mapStateToProps)(PrivateMortgageInsuranceInput);
